function hideLoadingIndicator() {
  $('#loading-indicator').addClass('d-none');
}

$(document).on('turbolinks:request-start', function () {
  $('#loading-indicator').removeClass('d-none');
});

$(document).on('turbolinks:request-end', function () {
  hideLoadingIndicator();
});

$(document).on('turbolinks:before-cache', function () {
  hideLoadingIndicator();
});

$(document).on('turbolinks:before-render', function () {
  hideLoadingIndicator();
});

$(document).on('turbolinks:render', function () {
  hideLoadingIndicator();
});

$(document).on('turbolinks:load', function () {
  hideLoadingIndicator();
  let buttonIds = ['#quickSearchSubmitButton', '#agrochemicalSearchSubmitButton', '#herbicideSearchSubmitButton', "#productSearchSubmitButton"];

  buttonIds.forEach(function (buttonId) {
    const button = $(buttonId);
    const form = button.closest('form');
    form.off('submit.loadingIndicator').on('submit.loadingIndicator', function () {
      $('#loading-indicator').removeClass('d-none');
      button.prop('disabled', true).attr('aria-disabled', 'true');
    });
  });

});

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    hideLoadingIndicator();
  }
});
